import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

// import Link from '../../../Core/Link';

import {
  Wrapper,
  StyledContainer,
  CenterImage,
  Content,
  OverviewWrapper,
  OverviewContainer,
  OverviewImage,
} from './styles';

function OverviewSection({ data }) {
  if (!data) return null;
  const {
    headingHtml,
    subheadingHtml,
    image,
    imageSharp,
    imageLeft1,
    imageLeft2,
    imageLeft3,
    imageLeft1Sharp,
    imageLeft2Sharp,
    imageLeft3Sharp,
    imageLeftText1Html,
    imageLeftText2Html,
    imageLeftText3Html,
    imageRight1Sharp,
    imageRight2Sharp,
    imageRight3Sharp,
    imageRight1,
    imageRight2,
    imageRight3,
    imageRightText1Html,
    imageRightText2Html,
    imageRightText3Html,
  } = data;

  return (
    <Wrapper>
      <StyledContainer className="auto-margin overview-section">
          {ReactHtmlParser(headingHtml)}
          {ReactHtmlParser(subheadingHtml)}
        <OverviewWrapper>
          <OverviewContainer className="left-side-container">
            <Content className="left-side">
              <OverviewImage src={imageLeft1Sharp} alt={imageLeft1.altTag} />
              {ReactHtmlParser(imageLeftText1Html)} 
            </Content>
            <Content className="left-side">
              <OverviewImage src={imageLeft2Sharp} alt={imageLeft2.altTag} />
              {ReactHtmlParser(imageLeftText2Html)}
            </Content>
            <Content className="left-side">
              <OverviewImage src={imageLeft3Sharp} alt={imageLeft3.altTag} />
              {ReactHtmlParser(imageLeftText3Html)}
            </Content>
          </OverviewContainer>
          <CenterImage src={imageSharp} alt={image.altTag} />
          <OverviewContainer className="right-side-container">
            <Content className="right-side">
              <OverviewImage src={imageRight1Sharp} alt={imageRight1.altTag} />
              {ReactHtmlParser(imageRightText1Html)}
            </Content>
            <Content className="right-side">
              <OverviewImage src={imageRight2Sharp} alt={imageRight2.altTag} />
              {ReactHtmlParser(imageRightText2Html)}
            </Content>
            <Content className="right-side">
              <OverviewImage src={imageRight3Sharp} alt={imageRight3.altTag} />
              {ReactHtmlParser(imageRightText3Html)}
            </Content>
          </OverviewContainer>
        </OverviewWrapper>
      </StyledContainer>
    </Wrapper>
  );
}

OverviewSection.propTypes = {
  data: PropTypes.shape().isRequired,
};

OverviewSection.defaultProps = {};

export default OverviewSection;
